import { iBrand } from "@sdk/brands/brand-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { brandsDefaultQueryConfig } from "./brands-default-query";

export const {
  slice: BrandsSlice,
  reducers: BrandsSliceReducer,
  actions: {
    setEntityQueryResults: setBrandsQueryResults,
    setEntity: setBrand,
    setEntities: setBrands,
    patchEntity: patchBrand,
    addNewEntity: addNewBrand,
    setEntityFetchingStatus: setBrandFetchingStatus,
    setEntitiesFetchingStatus: setBrandsFetchingStatus,
    setEntityFailedStatus: setBrandFailedStatus,
    setEntityQueryError: setBrandsQueryError,
    resetQuery: resetBrandsQuery,
    setQueryList: setBrandQueryList,
  },
} = CreateEntitySlice<iBrand>({
  sliceName: "brands",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...brandsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
